import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { makeGetTabOrder } from '../../../selectors/order'
import { makeGetDisplaySuiteByOrder, makeGetOrderPreferencesByOrder, getPaymentByOrder } from '../../../selectors/suites'
import { selectRemoteOrderTotal } from '../../../selectors/orderTotalRemote'

import { TabOrderDetailsViewModel } from '../../../viewmodels/TabOrderViewModel'

import { updateExemptions, getRemoteOrderTotal } from '../../../actions/orderTotalRemote'

import { makeExemptionOverridesFromOrder } from '../../../utils/exemptionUtils'

import AdjustExemptions from '../../../components/tabs/OrderDetailsModal/AdjustExemptions'

const mapStateToProps = (state, ownProps) => {
  const orderId = ownProps?.match?.params?.orderId ?? ''
  const getTabOrder = makeGetTabOrder()
  const getDisplaySuite = makeGetDisplaySuiteByOrder()
  const suiteInformation = getDisplaySuite(state, orderId)
  const tabOrder = getTabOrder(state, orderId)
  const order = TabOrderDetailsViewModel(tabOrder)
  const remoteOrderTotals = selectRemoteOrderTotal(state)
  const customerId = order?.customerId ?? ''
  const revenueCenterId = order?.revenueCenterUuid ?? ''
  const isOrderLatestFromServer = tabOrder?.latestFromServer ?? false
  const isSuiteCustomer = !!customerId && !!revenueCenterId
  const getOrderPreferencesByOrder = makeGetOrderPreferencesByOrder()

  let orderingPreference = {}
  let paymentOptions = []
  let paymentOnOrder = undefined

  if (isSuiteCustomer) {
    orderingPreference = getOrderPreferencesByOrder(state, orderId)
    const subtype = order?.orderType
    paymentOnOrder = getPaymentByOrder(state, orderId)
    paymentOptions = orderingPreference?.[subtype]?.payments ?? []
  }

  const exemptionOverrides = makeExemptionOverridesFromOrder(order)
  const userNotes = order?.userNotes ?? ''

  return {
    ...order,
    exemptionOverrides,
    customerId,
    amountDisplay: remoteOrderTotals?.totalsWithDiscount?.subtotalDisplay,
    isOrderLatestFromServer,
    orderingPreference,
    paymentOnOrder,
    paymentOptions,
    remoteOrderTotals,
    revenueCenterId,
    suiteInformation,
    userNotes,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const orderUuid = ownProps?.match?.params?.orderId ?? ''
  const historyState = ownProps?.history?.location?.state
  const customerId = historyState?.customerId
  const replace = ownProps?.history?.replace ?? function(){}

  return {
    onClose: () => {
      replace('/tabs')
    },
    onUpdateExemptions: (exemptions) => {
      dispatch(updateExemptions({ ...exemptions, orderUuid }))
      replace('/tabs')
    },
    getRemoteOrderTotal: (params) => {
      dispatch(getRemoteOrderTotal({ ...params, customerId }))
    },
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AdjustExemptions))
